import {Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment';


@Pipe({
  name: 'retrieveDateFromUI'
})

export class RetrieveDateFromUI implements PipeTransform {

  transform(value: any ): Date {
    if (value){
      if (value.hasOwnProperty('day') && value.hasOwnProperty('month') && value.hasOwnProperty('year')){
        console.log(JSON.stringify(value,null,1));
        // const bean = moment().date(value.day).month(value.month - 1).year(value.year).startOf('day');
        let str = ''+value.month+'-'+value.day+'-'+value.year;
        const bean = moment(str,'M-D-YYYY').startOf('day');
        console.log('res: ' + bean.format('LLL') + ' ' + value.day + ' ' + value.year + ' ' + value.month);
        return bean.toDate();
      }else{
        console.log('Can\'t retrieve the date from ' + JSON.stringify(value) + ', needs to have day, month, year fields.' );
        return null;
      }
    }
    return null;
  }


}


